import { PaypalCancelledError, StripeTokenInvalidError } from './errors';
import { isExpectedStripeError } from './stripe';

/**
 * Whether an error passed to `onTokenInvalid` is a user outcome that shouldn't be reported: the user
 * closed the PayPal popup (`PaypalCancelledError`), or Stripe returned an expected error such as a
 * card decline or an incomplete card/IBAN field (`StripeTokenInvalidError` + `isExpectedStripeError`).
 *
 * Matching by error class rather than by payment type keeps any other error reported, whichever
 * payment method it comes from.
 */
export function isExpectedTokenInvalidError(err: Error): boolean {
	if (err instanceof PaypalCancelledError) return true;
	if (err instanceof StripeTokenInvalidError) return isExpectedStripeError(err);
	return false;
}
